import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
interface PricingCardProps {
  title: string;
  price: string;
  billingType?: 'month' | 'one-time';
  description: string;
  features: string[];
  isPopular?: boolean;
  ctaText?: string;
}
export function PricingCard({
  title,
  price,
  billingType = 'month',
  description,
  features,
  isPopular = false,
  ctaText = 'Get Started'
}: PricingCardProps) {
  return <Card className={`flex flex-col h-full relative ${isPopular ? 'border-blue-500 ring-2 ring-blue-500 shadow-xl' : ''}`} data-id="element-115">
      {isPopular && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-116">
          <span className="bg-blue-600 text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wide shadow-lg" data-id="element-117">
            Most Popular
          </span>
        </div>}

      <div className="p-8 flex-1" data-id="element-118">
        <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-119">{title}</h3>
        <div className="flex items-baseline mb-2" data-id="element-120">
          <span className="text-4xl font-bold text-slate-900" data-id="element-121">{price}</span>
          {billingType === 'month' && <span className="text-slate-500 ml-2 text-lg" data-id="element-122">/month</span>}
        </div>
        <p className="text-sm text-slate-500 mb-4 font-medium" data-id="element-123">
          {billingType === 'month' ? 'Monthly subscription' : 'One-time payment'}
        </p>
        <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-124">{description}</p>

        <div className="space-y-3 mb-8" data-id="element-125">
          {features.map((feature, idx) => <div key={idx} className="flex items-start" data-id="element-126">
              <Check className="h-5 w-5 text-green-500 mr-3 shrink-0 mt-0.5" data-id="element-127" />
              <span className="text-sm text-slate-700 leading-relaxed" data-id="element-128">
                {feature}
              </span>
            </div>)}
        </div>
      </div>

      <div className="p-8 pt-0 mt-auto" data-id="element-129">
        <a href="https://wa.me/17863763985" target="_blank" rel="noopener noreferrer" className="block" data-id="element-130">
          <Button variant={isPopular ? 'primary' : 'outline'} className="w-full" size="lg" data-id="element-131">
            Contact Us
          </Button>
        </a>
      </div>
    </Card>;
}